var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    _vm._g(
      _vm._b(
        {
          ref: "comDialog",
          staticClass: "com_dialog",
          style: { "--paddings": _vm.attrs.paddings },
          attrs: { fullscreen: _vm.attrs.fullscreen || false },
        },
        "el-dialog",
        _vm.attrs,
        false
      ),
      _vm.$listeners
    ),
    [
      _vm.$slots.title
        ? _c("template", { slot: "title" }, [_vm._t("title")], 2)
        : _c("template", { slot: "title" }, [
            _c(
              "div",
              { staticClass: "original-title" },
              [
                _vm.attrs && _vm.attrs.titles
                  ? _c(
                      "h3",
                      [
                        _vm._v(_vm._s(_vm.attrs.titles) + " "),
                        _vm.attrs && _vm.attrs.titleInfo
                          ? _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  content: _vm.attrs.titleInfo,
                                  placement: "bottom",
                                },
                              },
                              [
                                _c(
                                  "svg",
                                  {
                                    staticClass: "icon svg-icon icon-help",
                                    attrs: { "aria-hidden": "true" },
                                  },
                                  [
                                    _c("use", {
                                      attrs: {
                                        "xlink:href": "#icon-bangchu14",
                                      },
                                    }),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.attrs && _vm.attrs.secTitle
                  ? _c(
                      "el-tooltip",
                      { attrs: { placement: "bottom", overflow: "" } },
                      [
                        _c("template", { slot: "content" }, [
                          _c("p", {
                            domProps: { innerHTML: _vm._s(_vm.attrs.secTitle) },
                          }),
                        ]),
                        _c("p", {
                          domProps: { innerHTML: _vm._s(_vm.attrs.secTitle) },
                        }),
                      ],
                      2
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]),
      _vm._t("default"),
      _vm.$slots.footer
        ? _c("template", { slot: "footer" }, [_vm._t("footer")], 2)
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }